'use client'

import Script from 'next/script'

import { useLocation } from '@marketplace-web/shared/browser-data'
import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

import { getPubstackDomainKey } from './utils'

const international_pubstack_domain_key = '67661136-7e02-42c4-9da1-8ab1f222b7fc'

const Pubstack = () => {
  const webIntPlacementAbTest = useAbTest('web_int_placements_v3')
  const country_pubstack_domain_key = getPubstackDomainKey(useLocation().host)

  const pubstackDomainKey =
    webIntPlacementAbTest?.variant === 'on'
      ? international_pubstack_domain_key
      : country_pubstack_domain_key

  if (!pubstackDomainKey) return null

  return (
    <Script
      id="pubstack-script"
      data-testid="pubstack-script"
      src={`https://boot.pbstck.com/v1/tag/${pubstackDomainKey}`}
      strategy="lazyOnload"
    />
  )
}

export default Pubstack
